require('./bootstrap');

window.Vue = require('vue');
window.bodyScrollLock = require('body-scroll-lock');

/**********
 * Vue.js components
 **********/
Vue.component('services-steps', require('./components/ServicesSteps.vue').default);

const app = new Vue({
    el: '#app'
});

/**********
 * Variables
 **********/
const body = document.querySelector('body'); // body element

const cursor = document.querySelector('#cursor'); // custom cursor

const header = document.querySelector('.site-header'); // header element
const headerHiddenSelector = 'header-hidden'; // class used on <body> for hiding header
const headerScrollSelector = 'header-scrolling'; // class used on <body> for header while scrolling

let scrollPosition = window.pageYOffset; // window scroll position
let didScroll;
let lastScrollTop = 0;
let headerHeight = header.offsetHeight; // header height
let delta = 5;

const themeToggleSwitch = document.querySelector('.theme-toggle__handle'); // theme toggle button

const menuToggle = document.querySelectorAll('.menu-toggle'); // mobile menu button
const menu = document.querySelector('.nav'); // main menu
const mobileMenuVisible = 'mobile-menu-visible'; // class used on <body> for mobile menu

const servicesSteps = document.querySelectorAll('.services-steps__item'); // services step item
const servicesMarker = document.querySelector('.services-steps__nav-marker'); // services slide marker

/**********
 * Dark/Light theme toggle
 **********/

// Set Dark Mode if cookie exists with value of 1
if (document.cookie.split(';').some((item) => item.includes('darkmode=true'))) {
    document.documentElement.setAttribute('data-theme', 'dark');
}

// Switch theme function
function switchTheme(e) {
    if (document.documentElement.getAttribute('data-theme') == 'light') {
    	// Switch to dark mode
        document.documentElement.setAttribute('data-theme', 'dark');

        // Create true dark mode cookie which expires in 24 hours
		document.cookie = 'darkmode=true; max-age=86400;';
    }
    else {
    	// Switch to light mode
        document.documentElement.setAttribute('data-theme', 'light');

        // Create false dark mode cookie which expires in 24 hours
		document.cookie = 'darkmode=false; max-age=86400;'; 
    }

    // On mobile, close mobile menu if opened
    if (body.classList.contains(mobileMenuVisible)) {
    	mobileMenuToggle();
    }
}

// Switch theme on toggle switch click
themeToggleSwitch.addEventListener('click', switchTheme, false);

/**********
 * Animated preloader
 **********/
// Check if visited cookie does not exist
if (!document.cookie.split(';').some((item) => item.includes('visited=true'))) {
	document.cookie = 'visited=true; max-age=86400;'; // Create visited cookie which expires in 24 hours
	document.querySelector('body').classList.add('preload-animate'); // Trigger preloader animation
} else {
	document.cookie = 'visited=true; max-age=86400;'; // Reset visited cookie which expires in 24 hours
}

// FOR TESTING ONLY
//document.querySelector('body').classList.add('preload-animate');

/**********
 * Get mouse position for custom cursor and detect if hovering interactive element (link, button, etc.)
 **********/
if (matchMedia('(pointer:fine)').matches) { // Check if normal mouse is used instead of touch screen
	document.body.onmousemove = function(e) {
		// Display and position custom cursor
		cursor.style.display = "block";
		document.documentElement.style.setProperty('--x', (e.clientX) + 'px');
		document.documentElement.style.setProperty('--y', (e.clientY) + 'px');

		// Get cursor target
		let target = e.target;
		// List of default interactive elements
		const interactive = '.cursor-interact, .cursor-plus, .cursor-h-arrows, a, button, input, textarea, select, label';
		// Check if target is interactive or as interactive parent
		let isInteractive = target.matches(interactive) || target.closest(interactive);
		// Check if cursor is currently hovering interactive element
		let hovering = document.body.classList.contains('cursor-hovering');

		// Class for showing (+) cursor on hover
		const plusCursor = '.cursor-plus';
		// Check if target is cursorPlus element or has cursorPlus parent
		let isPlus = target.matches(plusCursor) || target.closest(plusCursor);

		// Class for showing (<>) cursor on hover
		const hArrowsCursor = '.cursor-h-arrows';
		// Check if target is cursorPlus element or has cursorPlus parent
		let isArrows = target.matches(hArrowsCursor) || target.closest(hArrowsCursor);

		// Toggle cursor hovering class if hovering interactive element
		if (isInteractive) {

			// Normal hovering
			if (!hovering) {
				document.body.classList.add('cursor-hovering');
			}

			// Plus symbol cursor
			if (isPlus) {
				document.body.classList.add('cursor-show-plus');
			} else {
				document.body.classList.remove('cursor-show-plus');
			}

			// Horizontal arrows cursor
			if (isArrows) {
				document.body.classList.add('cursor-show-h-arrows');
			} else {
				document.body.classList.remove('cursor-show-h-arrows');
			}

		} else {
			// Remove cursor classes on body
			if (hovering) {
				document.body.classList.remove('cursor-hovering');
			}

			document.body.classList.remove('cursor-show-plus');
			document.body.classList.remove('cursor-show-h-arrows');
		}

		//console.log(target);
	}
}

/**********
 * Show/hide header when scrolling through page
 **********/
window.addEventListener('scroll', function () {
    scrollPosition = window.pageYOffset; // update scroll position
    didScroll = true; // on scroll, let the interval function know the user has scrolled

    // if scroll position not on top of page add class to <body> for fixed header with background
    if (scrollPosition >= 2) {
        body.classList.add(headerScrollSelector);
    } else {
        body.classList.remove(headerScrollSelector);
    }
});

let event = document.createEvent("HTMLEvents");
event.initEvent("scroll", false, true);
window.dispatchEvent(event);

function hasScrolled() {
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - scrollPosition) <= delta)
        return;

    // If they scrolled down, add class .header-hidden to <body>
    if (scrollPosition > lastScrollTop && scrollPosition > 2) {
        // Scroll Down
        if (document.querySelector('.menu-visible') == null) { // Check that menu is not already open
            //console.log('Hide header');
            body.classList.add(headerHiddenSelector);
        }
    } else {
        // Scroll Up
        // If did not scroll past the document (possible on mac)...
        if (scrollPosition + document.documentElement.clientHeight < document.documentElement.scrollHeight) {
            //console.log('Show header');
            body.classList.remove(headerHiddenSelector);
        }
    }

    lastScrollTop = scrollPosition;
}

// Run hasScrolled function and reset didScroll status
setInterval(function () {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

/**********
 * Anchor links smooth scroll
 **********/
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
    	e.preventDefault();
    	let href = this.getAttribute('href');

    	if (href == '#') {
    		// If href = #, smooth scroll back to top of page
        	window.scroll({top: 0, left: 0, behavior: 'smooth'}); 
        } else {
        	// Change hash on address bar
	    	history.replaceState({}, '', href);
	    	// Smooth scroll to section
	        document.querySelector(href).scrollIntoView({
	            behavior: 'smooth'
	        });
        }
    });
});

/**********
 * Mobile menu toggle
 **********/
function mobileMenuToggle() {
	// Add class to <body> to toggle main menu visibility on menu-toggle button click
    body.classList.toggle(mobileMenuVisible);

    // Toggle <body> scroll lock
    if (body.classList.contains(mobileMenuVisible)) {
        bodyScrollLock.disableBodyScroll(menu); // Disable scroll
    } else {
        bodyScrollLock.enableBodyScroll(menu); // Enable scroll
    }
}
menuToggle.forEach(button => button.addEventListener('click', function () {
    mobileMenuToggle();
}));

/**********
 * Mobile menu close when link clicked
 **********/
const navLinks = document.querySelectorAll('.nav__link');
navLinks.forEach(button => button.addEventListener('click', function () {
    if (body.classList.contains(mobileMenuVisible)) {
    	mobileMenuToggle();
    }
}));

/**********
 * Hero illustrations cycle
 **********/
const heroIllust = document.querySelectorAll('.hero__illust');
Array.prototype.forEach.call(heroIllust, function(el, i){
	let index = 0; // set index
	let illustrations = el.querySelectorAll('.hero__illust-img'); // get all images
	let numIllust = illustrations.length - 1; // get amount of images

	// Function for cycling through illustrations
	function cycleIllust() {
		if (index >= numIllust) {
			index = 0; // Reset cycle if reached end of illustrations set
		} else {
			index++; // Increment to next illustration
		}

		// Hide illustrations
		Array.prototype.forEach.call(illustrations, function(el, i){
			el.classList.remove('hero__illust-img--visible');
		});
		// Show new illustration
		illustrations[index].classList.add('hero__illust-img--visible');
	}

	// Check if touch screen is used
	if (window.matchMedia("(pointer: coarse)").matches) {
		// Automatically cycle through illustrations in set interval
		setInterval(function(){
			// Add small delay between 3 shown illustrations 
			setTimeout(function(){
				cycleIllust();
			}, 400 * i);
		}, 2000);
		//console.log(i + ' Touch cycle');
	} else {
		// Cycle through illustrations when mouse hovers on desktop
		el.addEventListener('mouseenter', function() {
			cycleIllust();
		});
		//console.log(i + ' Mouse cycle');
	}
});

/**********
 * Machine animation
 **********/
let machine = bodymovin.loadAnimation({
	container: document.getElementById('machine'),
	renderer: 'svg',
	loop: true,
	autoplay: true,
	path: '/machine.json'
});

/**********
 * Services steps
 **********/
 // Move circle marker to new active item
servicesSteps.forEach(step => step.addEventListener('click', function () {
	servicesMarker.style.transform = 'translateY(' + step.offsetTop + 'px)';
}));
// Adjust marker position on window resize
window.onresize = function () {
	servicesMarker.style.transform = 'translateY(' + document.querySelector('.services-steps__item--active').offsetTop + 'px)';
};

/**********
 * Home projects
 **********/
 const homeProjectsSection = document.querySelector('.section-projects'); // Home projects section
 const homeProjectsLinks = document.querySelectorAll('.home-projects__link'); // Home projects links

// Modify background color of home projects section based on hovered project assigned color
homeProjectsLinks.forEach(project => project.addEventListener('mouseover', function () {
	let projectColor = project.getAttribute('data-color');
	homeProjectsSection.style.background = projectColor;
}));
// Reset home projects section background color
homeProjectsLinks.forEach(project => project.addEventListener('mouseleave', function () {
	homeProjectsSection.style.background = '';
}));

/**********
 * Team slider
 **********/
const teamSlider = document.getElementById('team-slider'); // get element
let teamSliderPos, teamSliderHandleWidth, teamSliderWidth, teamSliderScrollWidth;

if (teamSlider !== null) {
	teamSliderPos = { left: 0, x: 0 }; // initial slider scroll position
}

// on slider click
const mouseDownSliderHandler = function(e) {
	teamSlider.style.userSelect = 'none'; // prevent text selection

	// update scroll position
	teamSliderPos = {
		// current scroll
		left: teamSlider.scrollLeft,
		// get current mouse position
		x: e.clientX,
	};

	document.addEventListener('mousemove', mouseMoveSliderHandler); // add mousemove event for scrolling
	document.addEventListener('mouseup', mouseUpSliderHandler); // add mouseup event for when click is released
};

// on slider drag
const mouseMoveSliderHandler = function(e) {
	// how far the mouse has been moved
	const dx = e.clientX - teamSliderPos.x;

	// scroll the element
	teamSlider.scrollLeft = teamSliderPos.left - dx;
};

// on click release
const mouseUpSliderHandler = function() {
	teamSlider.style.removeProperty('user-select'); // restore user select

	// remove mouse events
	document.removeEventListener('mousemove', mouseMoveSliderHandler);
    document.removeEventListener('mouseup', mouseUpSliderHandler);
};

// move scroller bar handle on team slider scroll
const teamSliderHandle = document.getElementById('team-slider-handle'); // get scroller handle
if (teamSliderHandle !== null) {
	teamSliderHandleWidth = teamSliderHandle.offsetWidth; // scroller handle width
	teamSliderWidth = teamSlider.offsetWidth; // slider width
	teamSliderScrollWidth = teamSlider.scrollWidth; // slider scroll width
}

// move scroller handle position
const moveSliderHandle = function() {
	teamSliderHandle.style.left = 'calc(' + (teamSlider.scrollLeft / (teamSliderScrollWidth - teamSliderWidth)) * 100 + '% - ' + teamSliderHandleWidth / 2 + 'px)'; 
};

if (teamSlider !== null) {
	teamSlider.addEventListener('scroll', function() {
		moveSliderHandle();
	});
}

// on scroller handle click
const mouseDownHandleHandler = function(e) {
	teamSlider.style.userSelect = 'none'; // prevent text selection

	// update scroll position
	teamSliderPos = {
		// current scroll
		left: teamSlider.scrollLeft,
		// get current mouse position
		x: e.clientX,
	};

	document.addEventListener('mousemove', mouseMoveHandleHandler); // add mousemove event for scrolling
	document.addEventListener('mouseup', mouseUpHandleHandler); // add mouseup event for when click is released
}

// on scroller handle drag
const mouseMoveHandleHandler = function(e) {
	// how far the mouse has been moved
	const dx = e.clientX - teamSliderPos.x;

	// scroll the element
	teamSlider.scrollLeft = teamSliderPos.left + ((dx / teamSliderWidth) * (teamSliderScrollWidth - teamSliderWidth));
};

// on handle click release
const mouseUpHandleHandler = function() {
	teamSlider.style.removeProperty('user-select'); // restore user select

	// remove mouse events
	document.removeEventListener('mousemove', mouseMoveHandleHandler);
    document.removeEventListener('mouseup', mouseUpHandleHandler);
};

// update handle position on window resize
window.onresize = function() {
	if (teamSlider !== null) {
		teamSliderHandleWidth = teamSliderHandle.offsetWidth;
		teamSliderWidth = teamSlider.offsetWidth;
		teamSliderScrollWidth = teamSlider.scrollWidth;

		moveSliderHandle();
	}
};

// attach mousedown handlers to elements
if (teamSlider !== null) {
	teamSlider.addEventListener('mousedown', mouseDownSliderHandler);
	teamSliderHandle.addEventListener('mousedown', mouseDownHandleHandler);
}

/**********
 * Team eye animation
 **********/
window.addEventListener('DOMContentLoaded', (event) => {
	if (matchMedia('(pointer:fine)').matches) { // Check if normal mouse is used instead of touch screen
		const teamMembers = document.querySelectorAll('.team-slider__illust-img'); // Get all team illustrations

		Array.prototype.forEach.call(teamMembers, function(el, i){
			const eyeball = el.querySelectorAll('.team-slider__eyeball'),
			      pupil = el.querySelectorAll('.team-slider__pupil');

			let eyeArea = eyeball[0].getBoundingClientRect(),
			    pupilArea = pupil[0].getBoundingClientRect(),
			    R = eyeArea.width/2,
			    r = pupilArea.width/2,
			    centerX = eyeArea.left + R + teamSlider.scrollLeft,
			    centerY = eyeArea.top + R + scrollPosition;

			// Position and rotate pupils based on mouse position relative to pupil center
			const movePupils = function(e) {
				let x = e.clientX + teamSlider.scrollLeft - centerX,
				    y = e.clientY + scrollPosition - centerY,
				    theta = Math.atan2(y,x),
				    angle = theta*180/Math.PI + 360;

			  	Array.prototype.forEach.call(pupil, function(el, i){
			  		el.style.transform = 'translateX(' + r*1.35 + 'px) rotate(' + angle + 'deg)';
				});
			};

			teamSlider.addEventListener('scroll', movePupils); // Update on team slider scroll
			document.addEventListener('scroll', movePupils); // Update on scroll
			document.addEventListener('mousemove', movePupils); // Update on mousemove
		});
	}
});

/**********
 * Disable dark/light theme CSS transitions before page fully loaded
 **********/
window.addEventListener('DOMContentLoaded', (event) => {
	body.classList.remove('preloading');
});